import ForgotPassword from '../../../app/auth/forgot';
import Login from '../../../app/auth/login';
import Otp from '../../../app/auth/otp';

export const publicRoutes = [
  {
    path: '/',
    component: <Login />,
  },
  {
    path: '/forgot-password',
    component: <ForgotPassword />,
  },
  {
    path: '/forgot-password-otp',

    component: <ForgotPassword isOtp />,
  },
  {
    path: '/verify-otp',
    component: <Otp />,
  },
];
